import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IconLookup,
  IconDefinition,
  findIconDefinition,
} from "@fortawesome/fontawesome-svg-core";
import countriesDropdownValues from "../Utils/CountriesUN";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import TextConfidential from "./InputComponents/TextConfidentialComponent";
import ConfirmationModal from "./Utils/ConfirmationModal";
import CardHeader from "./Utils/CardHeaderComponent";
import EditableTitle from "./InputComponents/EditableTitle";
import Tooltip from "./InputComponents/Tooltip";

library.add(faTrashCan);
const trashLookup: IconLookup = { prefix: "fas", iconName: "trash-can" };
const trashcanDefinition: IconDefinition = findIconDefinition(trashLookup);
library.add(faAngleRight);
const angleLookup: IconLookup = { prefix: "fas", iconName: "angle-right" };
const angleDefinition: IconDefinition = findIconDefinition(angleLookup);

interface ValidationError {
  field: string;
  message: string;
}

// Type pour une liste d'erreurs
type ValidationErrors = ValidationError[];
interface FeedstockProps {
  errors: string[];
  dropdownValues: {
    tab: string;
    inputName: string;
    listValue: string[];
  }[];
  customLabelValues : {
    table : string;
    property: string;
    value: string;
    id :string;
  }[];
  tAndP : 
    {
      table : string;
      property :string;
      tooltip : string;
      placeholder : string;
      id : string;
    }[];
  
  status: number;
  data: {
    typeOfFeedstock: string;
    typeOfFeedstockText: string;
    typeOfFeedstockSensitive: boolean;
    origin: string;
    originText: string;
    originSensitive: boolean;
    processedLocation: string;
    processedLocationText: string;
    processedLocationSensitive: boolean;
    isEnhancingBiodiversity: string;
    isEnhancingBiodiversityText: string;
    isEnhancingBiodiversitySensitive: boolean;
    zeroPollutionPractices: string;
    zeroPollution: boolean;
    reducingWaterConsumption: boolean;
    zeroPollutionPracticesText: string;
    zeroPollutionPracticesSensitive: boolean;
    mitigationOrAdaptationClimateChange: string;
    climateChangeMitigation: boolean;
    climateChangeAdaptation: boolean;
    mitigationOrAdaptationClimateChangeText: string;
    mitigationOrAdaptationClimateChangeSensitive: boolean;
  };
  isCBE: boolean;
  handleDeleteFeedstock: () => void;
  handleOnChangeFeedstock: (e: React.ChangeEvent<any>) => void;
  handleUpdateEditableTitle : (id : string, value: string)=>void;
}
function Feedstock({
  data,
  isCBE,
  status,
  errors,
  handleDeleteFeedstock,
  handleOnChangeFeedstock,
  dropdownValues,
  customLabelValues,
  handleUpdateEditableTitle,
  tAndP
}: FeedstockProps) {
  const { instance, accounts } = useMsal();
  const [isHidden, setIsHidden] = useState(true);
  const [groups, setGroups] = useState(["none"]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleVisibility = () => {
    setIsHidden((prevState) => !prevState);
  };
  const typeOfFeedstockTextIsValid = /^.{4,}$/.test(data.typeOfFeedstockText);
  const zeroPollutionPracticesTextIsValid = /^.{4,}$/.test(
    data.zeroPollutionPracticesText
  );
  const mitigationOrAdaptationClimateChangeTextIsValid = /^.{4,}$/.test(
    data.mitigationOrAdaptationClimateChangeText
  );
  const originTextIsValid = /^.{4,}$/.test(data.originText);
  const processedLocationTextIsValid = /^.{4,}$/.test(
    data.processedLocationText
  );
  const isEnhancingBiodiversityTextIsValid = /^.{4,}$/.test(
    data.isEnhancingBiodiversityText
  );
  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };
  const confirmDelete = () => {
    setIsModalOpen(false);
    handleDeleteFeedstock();
  };
  const cancelDelete = () => {
    setIsModalOpen(false);
  };
  console.log(errors);
  return (
    <>
      <div className="feedstock-container">
        <CardHeader
          isHidden={isHidden}
          toggleVisibility={toggleVisibility}
          cardName="Feedstock"
          handleDelete={status == 1 ? handleDeleteClick : null}
          notValid={errors.length > 0}
        />
        <div className={isHidden ? "hidden-content" : "visible-content"}>
          <div className="form-container">
            <div className="error-container">
              {errors.map((error, index) => (
                <div
                  className="error-text"
                  key={index}
                  style={{ marginBottom: "10px" }}
                >
                  {error}
                </div>
              ))}
            </div>
            <div className="questions-wrapper">
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <DropdownStringMandatory
                  listInputs={
                    dropdownValues.filter(
                      (item) => item.inputName == "typeOfFeedstock"
                    )[0].listValue
                  }
                  label={"Type of feedstock"}
                  inputName={"typeOfFeedstock"}
                  value={data.typeOfFeedstock}
                  handleOnChange={handleOnChangeFeedstock}
                  invalidValues={["-", ""]}
                />
              </div>

              <div className="col-md-6 col-sm-12">
                <div
                  className={
                    data.typeOfFeedstock == "-" ||
                    data.typeOfFeedstock == "" ||
                    data.typeOfFeedstock == "N/A"
                      ? "hidden-content"
                      : "visible-content"
                  }
                >
                  <TextConfidential
                    label={"Please explain"}
                    textValid={data.typeOfFeedstockText.length > 4}
                    textValue={data.typeOfFeedstockText}
                    textName={"typeOfFeedstockText"}
                    onChange={handleOnChangeFeedstock}
                    isConfidential={data.typeOfFeedstockSensitive}
                    confidentialInputName={"typeOfFeedstockSensitive"}
                    display={false}
                    editableTitle={<EditableTitle customLabelValue={customLabelValues.find(item => item.property == "TypeOfFeedstockText")}
                    handleUpdateEditableTitle={handleUpdateEditableTitle}/>}
                  />
                </div>
              </div>
            </div>
            <div
              className={
                data.typeOfFeedstock == "-" ||
                data.typeOfFeedstock == "" ||
                data.typeOfFeedstock == "N/A"
                  ? "hidden-content"
                  : "visible-content"
              }
            >
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <DropdownStringMandatory
                    listInputs={countriesDropdownValues.map(
                      (country) => country.name
                    )}
                    label={"Geographical origin of the feedstock"}
                    inputName={"origin"}
                    value={data.origin}
                    handleOnChange={handleOnChangeFeedstock}
                    invalidValues={["-", ""]}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <div
                    className={
                      data.origin == "Not defined"
                        ? "visible-content"
                        : "hidden-content"
                    }
                  >
                    <TextConfidential
                      label={"Please justify why origin is 'not defined'"}
                      textValid={data.originText.length > 4}
                      textValue={data.originText}
                      textName={"originText"}
                      onChange={handleOnChangeFeedstock}
                      isConfidential={data.originSensitive}
                      confidentialInputName={"originSensitive"}
                      display={false}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <DropdownStringMandatory
                    listInputs={countriesDropdownValues.map(
                      (country) => country.name
                    )}
                    label={"Location where the feedstock is processed"}
                    inputName={"processedLocation"}
                    value={data.processedLocation}
                    handleOnChange={handleOnChangeFeedstock}
                    invalidValues={["-", ""]}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <div
                    className={
                      data.processedLocation == "Not defined"
                        ? "visible-content"
                        : "hidden-content"
                    }
                  >
                    <TextConfidential
                      label={"Please justify why location is 'not defined'"}
                      textValid={data.processedLocationText.length > 4}
                      textValue={data.processedLocationText}
                      textName={"processedLocationText"}
                      onChange={handleOnChangeFeedstock}
                      isConfidential={data.processedLocationSensitive}
                      confidentialInputName={"processedLocationSensitive"}
                      display={false}
                    />
                  </div>
                </div>
              </div>
              {isCBE ? (
                <>
                  <div className="question-group-input">
                    <div className="row">
                      <div className="col-12 question-input">
                        <div className="form-group">
                        <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 3.1")?.tooltip}>
                          <div className="question-text">
                            CBE JU KPI 3.1  🛈 <br />
                            
                            <EditableTitle 
                            customLabelValue={customLabelValues.find(item => item.property == "IsEnhancingBiodiversity")}
                            handleUpdateEditableTitle={handleUpdateEditableTitle}
                            />
                          </div>
                          </Tooltip>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12 input-margin-top">
                        <DropdownStringMandatory
                          listInputs={["-", "Yes", "No"]}
                          label={""}
                          inputName={"isEnhancingBiodiversity"}
                          value={data.isEnhancingBiodiversity}
                          handleOnChange={handleOnChangeFeedstock}
                          invalidValues={["-", ""]}
                        />
                      </div>
                      <div className="col-12">
                        <div
                          className={
                            data.isEnhancingBiodiversity == "Yes"
                              ? "visible-content"
                              : "hidden-content"
                          }
                        >
                          <div className="form-group input-margin-top">
                            <TextConfidential
                              label={"Please describe the improved practices developed within the project, including how the outcomes are verified and quantified, with reference to the work package/task."}
                              textValid={
                                data.isEnhancingBiodiversityText.length > 4
                              }
                              textValue={data.isEnhancingBiodiversityText}
                              textName={"isEnhancingBiodiversityText"}
                              onChange={handleOnChangeFeedstock}
                              isConfidential={
                                data.isEnhancingBiodiversitySensitive
                              }
                              confidentialInputName={
                                "isEnhancingBiodiversitySensitive"
                              }
                              display={false}
                              placeholder={tAndP.find(item => item.property == "CBE JU KPI 3.1")?.placeholder}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="question-group-input">
                    <div className="row">
                      <div className="col-12 question-input">
                        <div className="form-group">
                          
                        <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 3.2")?.tooltip}>
                          <div className="question-text">
                            CBE JU KPI 3.2  🛈
                            <br />
                            
                            <EditableTitle 
                            customLabelValue={customLabelValues.find(item => item.property == "ZeroPollutionPractices")} 
                            handleUpdateEditableTitle={handleUpdateEditableTitle}/>
                          </div>
                          </Tooltip>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <DropdownStringMandatory
                          listInputs={["-", "Yes", "No"]}
                          label={""}
                          inputName={"zeroPollutionPractices"}
                          value={data.zeroPollutionPractices}
                          handleOnChange={handleOnChangeFeedstock}
                          invalidValues={["-", ""]}
                        />
                      </div>

                      <div
                        className={
                          data.zeroPollutionPractices == "Yes"
                            ? "visible-content"
                            : "hidden-content"
                        }
                      >
                        <div className="col-md-6 col-sm-12 yes-no-wrapper">
                          <div className="checkbox-text">
                            Zero pollution (soil,water, air)
                          </div>
                          <input
                            className="checkbox-input form-check-input"
                            type="checkbox"
                            checked={data.zeroPollution}
                            name="zeroPollution"
                            onChange={handleOnChangeFeedstock}
                          />
                        </div>

                        <div className="col-md-6 col-sm-12 yes-no-wrapper">
                          <div className="checkbox-text">
                            Reducing water consumpion
                          </div>
                          <input
                            className="checkbox-input form-check-input"
                            type="checkbox"
                            checked={data.reducingWaterConsumption}
                            name="reducingWaterConsumption"
                            onChange={handleOnChangeFeedstock}
                          />
                        </div>
                        <div className="col-12">
                          <div
                            className={
                              data.zeroPollutionPractices == "Yes"
                                ? "visible-content"
                                : "hidden-content"
                            }
                          >
                            <TextConfidential
                              label={"Please describe the improved practices developed within the project, including how the outcomes are verified and quantified, with reference to the work package/task."}
                              textValid={
                                data.zeroPollutionPracticesText.length > 4
                              }
                              textValue={data.zeroPollutionPracticesText}
                              textName={"zeroPollutionPracticesText"}
                              onChange={handleOnChangeFeedstock}
                              isConfidential={
                                data.zeroPollutionPracticesSensitive
                              }
                              confidentialInputName={
                                "zeroPollutionPracticesSensitive"
                              }
                              display={false}
                              
                              placeholder={tAndP.find(item => item.property == "CBE JU KPI 3.2")?.placeholder}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="question-group-input">
                    <div className="row">
                      <div className="col-12 question-input">
                        <div className="form-group">
                          <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 3.3")?.tooltip}>
                          <div className="question-text">
                            CBE JU KPI 3.3  🛈 <br />
                            
                            <EditableTitle 
                            customLabelValue={customLabelValues.find(item => item.property == "MitigationOrAdaptationClimateChange")} 
                            handleUpdateEditableTitle={handleUpdateEditableTitle}/>
                          </div>
                          </Tooltip>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <DropdownStringMandatory
                          listInputs={["-", "Yes", "No"]}
                          label={""}
                          inputName={"mitigationOrAdaptationClimateChange"}
                          value={data.mitigationOrAdaptationClimateChange}
                          handleOnChange={handleOnChangeFeedstock}
                          invalidValues={["-", ""]}
                        />
                      </div>

                      <div
                        className={
                          data.mitigationOrAdaptationClimateChange == "Yes"
                            ? "visible-content"
                            : "hidden-content"
                        }
                      >
                        <div className="col-md-6 col-sm-12 yes-no-wrapper">
                          <div className="checkbox-text">
                            Climate change mitigation
                          </div>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={data.climateChangeMitigation}
                            onChange={handleOnChangeFeedstock}
                            name="climateChangeMitigation"
                          />
                        </div>
                        <div className="col-md-6 col-sm-12 yes-no-wrapper">
                          <div className="checkbox-text">
                            Climate change adaptation
                          </div>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={data.climateChangeAdaptation}
                            onChange={handleOnChangeFeedstock}
                            name="climateChangeAdaptation"
                          />
                        </div>
                        <div className="col-12">
                          <div
                            className={
                              data.mitigationOrAdaptationClimateChange == "Yes"
                                ? "visible-content"
                                : "hidden-content"
                            }
                          >
                            <TextConfidential
                              label={"Please describe the improved practices developed within the project, including how the outcomes are verified and quantified, with reference to the work package/task."}
                              textValid={
                                data.mitigationOrAdaptationClimateChangeText
                                  .length > 4
                              }
                              textValue={
                                data.mitigationOrAdaptationClimateChangeText
                              }
                              textName={
                                "mitigationOrAdaptationClimateChangeText"
                              }
                              onChange={handleOnChangeFeedstock}
                              isConfidential={
                                data.mitigationOrAdaptationClimateChangeSensitive
                              }
                              confidentialInputName={
                                "mitigationOrAdaptationClimateChangeSensitive"
                              }
                              display={false}
                              placeholder={tAndP.find(item => item.property == "CBE JU KPI 3.3")?.placeholder}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onRequestClose={cancelDelete}
        onConfirm={confirmDelete}
        title="
        Confirm deletion"
        message="Are you sure you want to delete this component ?"
      />
    </>
  );
}

export default Feedstock;
